<template>
  <a-card :bordered="false">
    <div style="margin-bottom:20px;">
      <a-button @click="goAddRule(0)" type="primary">添加佣金规则</a-button>
    </div>
    <custom-page-table
      ref="tableList"
      :queryParams="queryParams"
      :columns="columns"
      base-key="payUrl"
      params-path="commissionRule/getCommissionRuleList"
    >
      <span slot="action" slot-scope="rowItem">
        <a style="margin-right: 10px;" @click="goAddRule(rowItem.record.ruleId)"
        >编辑</a
        >
        <a-popconfirm title="是否要删除当前标签？" @confirm="deleteRule(rowItem.record.ruleId)">
          <a type="danger">删除</a>
        </a-popconfirm>
      </span>
    </custom-page-table>
  </a-card>
</template>

<script>
export default {
  name: 'CommissionRule',
  data() {
    return {
      columns: [
        {
          title: '规则名称',
          dataIndex: 'ruleName'
        },
        {
          title: '规则方式',
          dataIndex: 'ruleTypeStr'
        },
        {
          title: '规则内容',
          dataIndex: 'ruleValueStr'
        },
        {
          title: '优先级',
          dataIndex: 'rulePriorityStr'
        },
        {
          title: '创建时间',
          dataIndex: 'ruleCreateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      queryParams: {}
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'CommissionHelper', title: '佣金分配记录' },
      { name: 'CommissionRule', title: '佣金规则' }
    ])
  },
  methods: {
    goAddRule(id) {
      this.openNewPage('AddCommissionRule', {
        id: id,
        serverUniqueId: this.$route.query.serverUniqueId,
        serverId: this.$route.query.serverId
      })
    },
    //删除接口
    deleteRule(ruleId) {
      this.getHttpServices()
        .getPayApiService()
        .post('commissionRule/deleteCommissionRule/' + ruleId)
        .then(res => {
          this.$message.success('删除成功')
          this.$refs.tableList.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    }

  }
}
</script>
<style scoped>
</style>
